// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseStepPhase } from './ResponseStepPhase';
import {
  ResponseStepPhaseFromJSON,
  ResponseStepPhaseFromJSONTyped,
  ResponseStepPhaseToJSON,
  ResponseStepPhaseToJSONTyped,
} from './ResponseStepPhase';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';

/**
 *
 * @export
 * @interface ResponseClusterCurrentStep
 */
export interface ResponseClusterCurrentStep {
  /**
   * Approved is null for the completion step, which needs no approval.
   * @type {boolean}
   * @memberof ResponseClusterCurrentStep
   */
  approved?: boolean;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  approvedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  completedAt?: string;
  /**
   * CooldownEndsAt is set only while the step is cooling down.
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  cooldownEndsAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  name?: string;
  /**
   *
   * @type {ResponseStepPhase}
   * @memberof ResponseClusterCurrentStep
   */
  phase?: ResponseStepPhase;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseClusterCurrentStep
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  transferFinishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCurrentStep
   */
  transferStartedAt?: string;
}

/**
 * Check if a given object implements the ResponseClusterCurrentStep interface.
 */
export function instanceOfResponseClusterCurrentStep(
  value: object,
): value is ResponseClusterCurrentStep {
  return true;
}

export function ResponseClusterCurrentStepFromJSON(
  json: any,
): ResponseClusterCurrentStep {
  return ResponseClusterCurrentStepFromJSONTyped(json, false);
}

export function ResponseClusterCurrentStepFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterCurrentStep {
  if (json == null) {
    return json;
  }
  return {
    approved: json['approved'] == null ? undefined : json['approved'],
    approvedAt: json['approvedAt'] == null ? undefined : json['approvedAt'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    cooldownEndsAt:
      json['cooldownEndsAt'] == null ? undefined : json['cooldownEndsAt'],
    name: json['name'] == null ? undefined : json['name'],
    phase:
      json['phase'] == null
        ? undefined
        : ResponseStepPhaseFromJSON(json['phase']),
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    transferStartedAt:
      json['transferStartedAt'] == null ? undefined : json['transferStartedAt'],
  };
}

export function ResponseClusterCurrentStepToJSON(
  json: any,
): ResponseClusterCurrentStep {
  return ResponseClusterCurrentStepToJSONTyped(json, false);
}

export function ResponseClusterCurrentStepToJSONTyped(
  value?: ResponseClusterCurrentStep | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    approved: value['approved'],
    approvedAt: value['approvedAt'],
    completedAt: value['completedAt'],
    cooldownEndsAt: value['cooldownEndsAt'],
    name: value['name'],
    phase: ResponseStepPhaseToJSON(value['phase']),
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    startedAt: value['startedAt'],
    transferFinishedAt: value['transferFinishedAt'],
    transferStartedAt: value['transferStartedAt'],
  };
}
